import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { imgUrl } from "@/utils/media";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Guides() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    fetch(`${API}/posts`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setPosts)
      .catch(() => setPosts([]));
  }, []);

  return (
    <div className="pt-16">
      <Seo
        title="Flooring Guides | Crownvera Epoxy Cleveland, OH"
        description="Expert epoxy flooring guides from Crownvera Epoxy — metallic finishes, flake systems, garage coatings, concrete care and more for Northeast Ohio homes."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-8 pt-20 pb-24" data-testid="guides-page">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-amber-700 mb-4">Flooring Guides</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-stone-900 leading-tight">
            Learn before you <span className="text-gold-shimmer italic">pour.</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base text-stone-600 leading-relaxed">
            Straight answers from the crew that pours them — pick a topic below.
          </p>
        </Reveal>

        {posts === null ? null : posts.length === 0 ? (
          <p className="text-stone-500 text-center py-24" data-testid="guides-empty">Guides are on the way — check back soon.</p>
        ) : (
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.08}>
                <Link to={`/guides/${p.slug}`} data-testid={`guide-card-${p.slug}`} className="gold-ring-card group block rounded-lg overflow-hidden h-full">
                  {p.image && (
                    <div className="h-44 overflow-hidden">
                      <img src={imgUrl(p.image)} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    </div>
                  )}
                  <div className="p-6">
                    <p className="text-xs text-stone-400">{new Date(p.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
                    <h2 className="font-display text-xl text-amber-900 mt-2 leading-snug">{p.title}</h2>
                    {p.excerpt && <p className="text-sm text-stone-500 mt-2 leading-relaxed line-clamp-3">{p.excerpt}</p>}
                    <span className="mt-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-amber-700">
                      Read guide <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
